<template>
  <div :class="['group-item', {open: isVisible}]">
    <div class="group-item--header" @click="toggleContent">
      <component :is="props.headingTag" v-if="props.heading" v-clean-html="props.heading" :class="props.headingClass" class="group-item__headline" />
      <div v-if="!isVisible" class="group-item__button">
        <PflegeButton size="1.5rem" icon="add-line" variant="text" />
      </div>
    </div>
    <Transition name="expand">
      <div v-if="isVisible" class="group-item--expansion">
        <slot name="expansion"></slot>
        <div class="group-item__button">
          <PflegeButton size="1.5rem" icon="remove-line" variant="text" @click="toggleContent" />
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import PflegeButton from '../Button'
import { HeadlineTagTypes } from '../../../constants/enums.js'

const props = defineProps({
  heading: {
    type: String,
    default: '',
  },
  headingTag: {
    type: String,
    default: 'h3',
    validator: (value) => HeadlineTagTypes.includes(value),
  },
  headingClass: {
    type: String,
    default: 'h3',
    validator: (value) => HeadlineTagTypes.includes(value),
  },

})

const isVisible = ref(false)

const toggleContent = () => {
  isVisible.value = !isVisible.value
}
</script>

<style lang="scss" scoped>
@use '../../../styles' as index;

.group-item {
  margin-bottom: 1.5rem;

  &:last-of-type {
    margin-bottom: .75rem;
  }

  &--header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-inline: 1rem;
    background-color: index.$secondaryMintLight;
    position: relative;
    border-radius: 0.25rem;

    .open & {
      border-radius: 0.25rem 0.25rem 0 0;
    }
  }

  &--expansion {
    position: relative;
    border: 1px solid index.$secondaryMintLight;
    border-radius: 0 0 0.25rem 0.25rem;
  }

  &__headline {
    color: index.$black;

    &::before {
      content: counter(section) ". ";
      counter-increment: section 1;
    }
  }

  &__button {
    transform: translateY(50%);
    position: absolute;
    right: 1rem;
    border: 1px index.$secondaryMintLight solid;
    border-radius: 50% 50%;
    bottom: 0;
    display: flex;
    justify-content: center;
  }
}

.expand-enter-active,
.expand-leave-active {
  transition: opacity var(--time2) ease;
}

.expand-enter-from,
.expand-leave-to {
  opacity: 0;
}
</style>
